<template>
  <div class="cart Cart.vue full-container block">
    <div class="cart__content">
      <a href="javascript:void(0);" class="go-back" @click="goBack()">
        <arrowBack id="arrow-back"></arrowBack>
      </a>

      <h1 class="title-primary animated fadeInDown delay1000ms">Legal <span class="sub">!</span></h1>

      <h2 class="text-second animated fadeInDown delay1000ms">
        Projetos novos são sempre motivantes e desafiadores. Nos informa quais serviços você precisa pra que possamos te
        entender melhor ainda:
      </h2>
      <!-- /.text-second -->

        <div class="clearfix"></div>
        <!-- /.clearfix -->


        <div class="content animated fadeInUp delay1000ms">

          <div class="row">



            <div class="col-md-3 conteudo">

              <!-- /.item-header -->

              <div class="video__ctn">
                <video playsinline preload autoplay muted style="max-height: 250px">
                  <source src="/static/media/vod-conteudo.mp4" type="video/mp4">
                </video>
                <img src="/static/media/vod-conteudo.gif" alt="">
              </div>

              <div class="item-header"><h3>Bold Digital</h3></div>
              <a href="javascript:void(0);"  @click="toggleCheck()">
              <checkboxSwitcher value="Inbound Marketing,Performance,Gerenciamento de Redes Sociais" />
              </a>
                <ul class="choicesBox">
                  <li>Inbound Marketing</li>
                  <li>Performance</li>
                  <li>Gerenciamento de Redes Sociais</li>
                </ul>
              <!-- /.choicesBox -->
              <div class="clearfix"></div>
            </div>
            <!-- /.item -->

            <div class="col-md-3 inbound hidden">

              <!-- /.item-header -->

              <div class="video__ctn">
                <video playsinline preload autoplay muted style="max-height: 250px">
                  <source src="/static/media/vod-inbound.mp4" type="video/mp4">
                </video>
                <img src="/static/media/vod-inbound.gif" alt="">
              </div>
              <div class="item-header"><h3>Inbound</h3></div>
              <a href="javascript:void(0);" @click="toggleCheck()">
              <checkboxSwitcher />
              </a>
                <ul class="choicesBox">
                  <li>Inbound Marketing</li>
                  <li>Conteúdo para blog</li>
                  <li>SEO</li>
                  <li>Criação de materiais ricos</li>
                  <li>Gerenciamento de RD Station</li>
                  <li>Fluxos de automação de E-mail</li>
                  <li>Mídia Digital</li>
                </ul>
              <!-- /.choicesBox -->
              <div class="clearfix"></div>
            </div>
            <!-- /.item -->


            <div class="col-md-3 tecnologia">

              <!-- /.item-header -->

              <div class="video__ctn">
                <video playsinline preload autoplay muted style="max-height: 250px">
                  <source src="/static/media/vod-tecnologia.mp4" type="video/mp4">
                </video>
                <img src="/static/media/vod-tecnologia.gif" alt="">

              </div>
              <div class="item-header"><h3>Bold Web</h3></div>
              <a href="javascript:void(0);" @click="toggleCheck()">
              <checkboxSwitcher value="Sites,E-commerce" />
              </a>
                <ul class="choicesBox">
                  <li>Sites</li>
                  <li>E-commerce</li>
                </ul>
              <!-- /.choicesBox -->
              <div class="clearfix"></div>

            </div>
            <!-- /.item -->
            <!-- /.content -->

            <div class="col-md-3 propaganda">

              <!-- /.item-header -->

              <div class="video__ctn">
                <video playsinline preload autoplay muted style="max-height: 250px">
                  <source src="/static/media/vod-campanha.mp4" type="video/mp4">
                </video>
                <img src="/static/media/vod-campanha.gif" alt="">
              </div>
              <div class="item-header"><h3>Bold Propaganda</h3></div>
              <a href="javascript:void(0);" @click="toggleCheck()">
                <checkboxSwitcher value="Mídia Off" />
              </a>
              <ul class="choicesBox">
                <li>Mídia Off</li>
              </ul>
              <!-- /.choicesBox -->

              <div class="clearfix"></div>
            </div>
            <!-- /.item -->

          </div>
          <!-- /.items -->

          <br><br><br>

          <div class="clearfix"></div>
          <!-- /.clearfix -->

          <!-- /.btn btn-bold -->
        </div>
      <div class="btn-fixed hidden">
      <button class="btn btn-bold btn-lg btn-finish animated fadeIn" @click="goToForm" style="margin: 22px 0">Continuar</button>
      </div>
    </div>
  </div>

</template>

<script>
  import arrowBack from '../arrowBack.vue'
  import checkboxSwitcher from '../checkboxSwitcher.vue'
  import checkMate from '../../assets/checkbox.svg'
  import slideArrow from '../../assets/arrow-right.svg'
  import slick from 'slick-carousel'

  export default {
    name: 'Cart',
    data() {
      return {
        form: {}
      }
    },
    components: {
      checkMate,
      arrowBack,
      slideArrow,
      checkboxSwitcher
    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      }
    },
    mounted() {
      this.log('mounted: ' + this.$options.name);
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', '');

      let isMobileWidth = window.outerWidth < 767;
      let totalSlides = 4;

      if (isMobileWidth) {
        return;
      }

      let video = document.querySelector('.cart video');
      video.currentTime = 0;
      setTimeout(() => {
        video.play();
      }, 1000);


      setTimeout(() => {
        $('.cart .categories').slick({
          arrows: false,
          infinite: false,
          fade: true
        });
      }, 200);


    },
    beforeDestroy() {
      $('.phone').unmask();
      try {
//        $('.content .items').slick('unslick');
      } catch (e) {
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      toggleCheck() {
        if ($('.switch__container input:checked').length > 0) {
          $('.btn-fixed').removeClass('hidden')
        } else {
          $('.btn-fixed').addClass('hidden');
        }
      },
      goToForm(event) {
        event.preventDefault();
        if ($('.switch__container input:checked').length < 1) {
          alert('Selecione pelo menos uma das opções exibidas!');
          return false;
        }

        let interestList = $('.switch__container input:checked').map(function(){
          return  $(this).val().replace(/\r?\n|\r/, '') ;
        }).toArray().join(',');

        this.$store.commit('setBusinessInterests', interestList);
        this.$router.push('/client/contact');
        return false;
      },
      resizeTextarea(event) {
        let el = event.target;
        setTimeout(function () {
          el.style.cssText = 'height:auto;';
          el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
        }, 0);
      },
      chekEmptyField(event) {
        let el = $(event.target);
        if (el.val().length > 0) {
          el.parent().addClass('white');
        } else {
          el.parent().removeClass('white');
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/client/Cart.vue